import { gql } from '@apollo/client';
import { SaleItemImageFragment } from 'graphql/SaleItemImage/fragments/SaleItemImageFragment';
/**
 * @const SaleItemSearchListQuery
 * @since 1.0.0
 */
export const SaleItemSearchListQuery = gql `
  query SaleItemSearchListQuery($input: SaleItemsInput) {
    saleItems(input: $input) {
      items {
        id
        sku
        title

        image {
          ...SaleItemImageFragment
        }

        variants {
          id
          active
        }
      }
    }
  }
  ${SaleItemImageFragment}
`;
